import { Route, Switch } from "react-router-dom";
import { Landing } from "./Screens/Landing";
import AboutUs from "./Screens/AboutUs";
import FAQ from "./Screens/FAQ";
import Contact from "./Screens/Contact";
import Driver from "./Screens/Driver";
import { Working } from "./Screens/Working/Working";
import "./App.css";

function App() {
  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route exact path="/nosotros" component={AboutUs} />
      <Route exact path="/faq" component={FAQ} />
      <Route exact path="/contacto" component={Contact} />
      <Route exact path="/conduce" component={Driver} />
      <Route exact path="*" component={Working} />
    </Switch>
  );
}

export default App;
